import { httpsCallable } from "firebase/functions";
import { getStorage, ref, deleteObject } from "firebase/storage";
import { getFirebaseFunctions } from "../../../firebase";

interface Request {
  userId: string;
  imageId: string;
}

interface Response {}

export const deleteUserImage = async (
  userId: string,
  imageId: string,
  filePath: string,
) => {
  const functions = getFirebaseFunctions();
  const storage = getStorage();

  try {
    const storageRef = ref(storage, filePath);
    await deleteObject(storageRef);

    const deleteUserImage = httpsCallable<Request, Response>(
      functions,
      "admin_deleteUserImage",
    );

    await deleteUserImage({ userId, imageId });

    return {
      success: true,
      message: "画像が正常に削除されました"
    };
  } catch (error: unknown) {
    console.error("画像削除エラー:", error);
    return {
      success: false,
      message: "画像の削除に失敗しました"
    };
  }
};
